(function($){
 
  $.fn.shuffle = function() {

      var allElems = this.get(),
          getRandom = function(max) {
              return Math.floor(Math.random() * max);
          },
          shuffled = $.map(allElems, function(){
              var random = getRandom(allElems.length),
                  randEl = $(allElems[random]).clone(true)[0];
              allElems.splice(random, 1);
              return randEl;
         });

      this.each(function(i){
          $(this).replaceWith($(shuffled[i]));
      });

      return $(shuffled);

  };

})(jQuery);

$(".owl-variants .dmc-variant-card").shuffle();
$('.owl-variants').owlCarousel({
  loop:true,
  margin:20,
  autoplay: true,
  nav:false,
  responsive:{
      0:{
          items:1
      },
      600:{
          items:2
      },
      1000:{
          items:3
      },
      1600:{
        items:4
      }
  }
});

$( document ).ready(function() {
  
  $('.owl-products').owlCarousel({
    loop:false,
    margin:35,
    autoplay: false,
    nav:true,
    responsive:{
      0:{
        center:true,
        autoWidth:true,
        margin: 10,
        nav: true
      },
      600:{
        items:2,
        center:true
      },
      1000:{
        items:3
      }
    }
  });

});

$('.dmc-filter-fetch .dmc-filter-option').on('click', function(){

  const $filter = $(this);
  setActive( $filter );

  const coffeeType = document.querySelector('.sub-filter-coffee-type .dmc-filter-option.active').dataset.label.replace(new RegExp(' ', 'g'), '+');
  const roastLevel = document.querySelector('.sub-filter-roast-level .dmc-filter-option.active').dataset.label.replace(new RegExp(' ', 'g'), '+');

  fetchProducts( coffeeType, roastLevel );

});

$('body').on('click', '.dmc-variant-list .dmc-filter-option', function(){

  const $filter = $(this);
  setActive( $filter );

  const variant_title = $filter.find('h4').text();
  $('.resume-variant-title').html( variant_title );

  const variant_price = $filter.find('.h2.price').text().replace('$', '');
  const variant_compare_price = $filter.find('.h2.compare-at').text().replace('$', '');
  const variant_disc = $filter.data('disc') != '' ? $filter.data('disc') : 0;
  const bundle_disc_money = variant_compare_price * (variant_disc / 100);

  $('.shopify-product-form input[name="id"]').val( $filter.data('id') );

  $('.summary-totals-table .variant-price p:last-child').html( '$' + (variant_compare_price || variant_price ) );
  $('.summary-totals-table .subs_disc p:last-child').html( '-$' + (variant_price * 0.05).toFixed(2) );
  $('.summary-totals-table .bundle_disc p:last-child').html( '-$' + bundle_disc_money.toFixed(2) );
  $('.summary-totals-table .bundle_disc p:first-child').html( 'Bundle disccount (Save '+ (variant_disc * 1)  +'%)' );
  $('.summary-totals-table .subtotal p:last-child').html( '$' + (variant_price * 0.95).toFixed(2) );

  $('.disc-text').html( variant_disc * 1 + 5 );

  if ( variant_disc ) {
    $('.summary-totals-table .bundle_disc').show();
  } else {
    $('.summary-totals-table .bundle_disc').hide();
  }

});

$('body').on('click', '.dmc-sub-plans .dmc-filter-option', function(){

  const $filter = $(this);
  setActive( $filter );

  const plan_title = $filter.find('h4').text();
  $('.resume-plan-title').html( plan_title );

  $('.shopify-product-form input[name="selling_plan"]').val( $filter.data('id') );

});

function setActive( $option) {
  $option.addClass('active').siblings('.active').removeClass('active');
}

async function fetchProducts( coffeeType, roastLevel ) {
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  const tempContent = new DOMParser().parseFromString(await (await cachedFetch('collections/subscription?filter.p.m.custom.roast_level='+ roastLevel +'&filter.v.option.coffee+type='+ coffeeType)).text(), "text/html");
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  
  const variant_cards = tempContent.querySelectorAll('.dmc-variant-list .dmc-sub-variant-card');
  const sub_resume = tempContent.querySelector('.dmc-subscription-resume');
  const temp_plans_wrapper = tempContent.querySelector('.dmc-sub-plans');
  const temp_roast_info = tempContent.querySelector('.dmc-roast-info');

  const cards_wrapper = document.querySelector('.dmc-variant-list');
        cards_wrapper.innerHTML = '';

  variant_cards.forEach(function(node) {
    cards_wrapper.appendChild(node);
  });

  const resume_wrapper = document.querySelector('.dmc-subscription-resume');
        resume_wrapper.innerHTML = sub_resume.innerHTML;

  const plans_wrapper = document.querySelector('.dmc-sub-plans');
        plans_wrapper.innerHTML = temp_plans_wrapper.innerHTML;

  const roast_info = document.querySelector('.dmc-roast-info');
        roast_info.innerHTML = temp_roast_info.innerHTML;

  hide_show_more();
}

var cachedMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  return fetch(window.Shopify.routes.root + url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}

const $morePacks = $('.dmc-more-packs');


  const $packsWrapper = $morePacks.prev(),
        $variantList = $packsWrapper.find('.dmc-variant-list'),
        $morePacksBtt = $morePacks.find('p');

  function setPacksHeight() {
    if ( !$packsWrapper.hasClass('open') ) {
      const $products = $variantList.find('.dmc-filter-option');
      const optionHeight = $products.outerHeight();
      $variantList.css('height', (optionHeight + 5 ) + 'px');
      $packsWrapper.removeClass('open');
      $morePacksBtt.text('View more products');
    }
  }

  function hide_show_more() {
    const $products = $variantList.find('.dmc-filter-option');
    
    if ( $products.length > getRowCount() ) {
      $morePacksBtt.show();
      hideProducts();
    } else {
      $morePacksBtt.hide();
    }
  }

  function getRowCount() {
    const $products = $variantList.find('.dmc-filter-option');
    const parentW = $variantList.width();
    const optionW = $products.outerWidth();
    let counter = 1;
    let rowCount = 0;

    while ( optionW * counter < parentW ) {
      counter++;
      rowCount = counter - 1;
    }

    return rowCount;
  }

  function hideProducts() {
    const products = $variantList[0].querySelectorAll('.dmc-filter-option');
    let rowCount = getRowCount();

    products.forEach((product, index) => {
      if ( index + 1 > rowCount ) {
        product.style.display = 'none';
      }
    });

    $packsWrapper.removeClass('open');
    $morePacksBtt.text('View more products');
  }

  function showProducts() {
    const products = $variantList[0].querySelectorAll('.dmc-filter-option');

    products.forEach(product => {
      product.style.display = 'flex';
    });

    $packsWrapper.addClass('open');
    $morePacksBtt.text('View less products');
  }

  if ( $morePacks.length ) setupPacks();

  function setupPacks() {
    hide_show_more();
    $morePacksBtt.on('click', function(){
      if ( $packsWrapper.hasClass('open') ) {
        hideProducts();
      } else {
        showProducts();
      }
    });
  }



const $body = $('body');
const $welkit_popup = $('.welcome-kit-popup');

if ( $welkit_popup.length ) {
 
  //$body.addClass('popup-open');

  $body.on('click', '.welkit-main .dmc-filter-option', function(){
    const $filter = $(this);
    setActive( $filter );
    updateChoosenPack();
  });

  // $('.button-welcome .button').on('click', function(){
  //   $body.addClass('popup-open');
  // });

  updateChoosenPack();
  function updateChoosenPack() {
    const $roast_level = $('.welkit-roast-level .dmc-filter-option.active');
    const product_title = $roast_level.find('h4').text();
    const coffee_type = $('.welkit-coffee-type .dmc-filter-option.active').find('h4').text();
    const selling_plan = $roast_level.data('selling-plan');
    const variant_id = coffee_type == 'Coffee Beans' ? $roast_level.data('beans-id') : $roast_level.data('ground-id');
    const $product_form = $('.welkit-main .shopify-product-form');
    $('.welkit-product-title').html( product_title );
    $('.dmc-variant-title').html( coffee_type + ' / 12oz / Pack x3' );
    $product_form.find('input[name="selling_plan"]').val( selling_plan );
    $product_form.find('input[name="id"]').val( variant_id );
    //$product_form.append('<input type="hidden" name="properties[welcome_kit]" value="true" />');
  } 
}

if ( $body.hasClass('dmc-homepage') ) {

  // setTimeout(function(){
  //   $body.addClass('popup-open');
  // }, 5000);
  
}

$body.on('click', '.popup-overlay', function(e){
  const $target = $(e.target);
  if ( $target.hasClass('popup-overlay') ) {
    $body.removeClass('popup-open');
  }
});

$body.on('click', '.close-popup', function(e){
  $body.removeClass('popup-open');
});

$body.on('click', function(e){
  const $target = $(e.target);
  if ( !$target.hasClass('dmc-account-open') && !$target.parents().hasClass('dmc-account-open') ) {
    $body.removeClass('open-customer-menu');
  }
});

$('.dmc-account-open').on('click', function(e){
  $body.toggleClass('open-customer-menu');
  e.preventDefault();
});

const $product_cards = document.querySelectorAll('.product-list .dmc-variant-card');
if ( $product_cards.length ) {
  $product_cards.forEach( (card, index) => {

    const randomNum = Math.ceil(Math.random() * $product_cards.length),
          order = index ? randomNum + 1 : 1;

    card.style.order = randomNum;

  });
}